import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Editor } from "./pages/Editor";
import { Landing } from "./pages/Landing";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/e/:id" element={<Editor />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
